import React from 'react';
import { Box } from '@mui/material';

import { ReactComponent as ErrorIcon } from 'assets/images/ic-modal-alert.svg';
import { Button, Container, ContainerItem, Dialog } from 'ui';
import { Header, Text } from 'ui/atoms';

interface LicenseNotFoundConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const LicenseNotFoundConfirmationModal: React.FC<LicenseNotFoundConfirmationModalProps> = (props) => {
  const { isOpen, onClose, onSubmit } = props;

  return (
    <Dialog
      handleClose={onClose}
      isOpen={isOpen}
      noCancelAction
      action={
        <Button fullWidth color="primary" label="Ok, upload anyway" onClick={onSubmit} dataCy="ok-button" />
      }
    >
      <Container column data-cy="verify-license-container" padding={0} width="100%">
        <ContainerItem justify="center" height="330px" width="100%">
          <Box sx={{ color: (theme) => theme.palette.error.main }}>
            <ErrorIcon />
          </Box>
          <br />
          <Header type="h2" content="License was not found" />
          <br />
          <Text content="We are sorry about that. We use a third-party license validation service and it appears we couldn't find a match given the details provided." />
        </ContainerItem>
      </Container>
    </Dialog>
  );
};
